import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import routes from '../config/routes';
import { reportFilterCountryCodeSelector } from '../state';

interface GcsByTaxSwitchProps {
  checked?: boolean;
  disabled?: boolean;
}

const GcsByTaxSwitch = ({ checked = false, disabled = false }: GcsByTaxSwitchProps) => {
  const country = useSelector(reportFilterCountryCodeSelector);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const disabledCountries = ['BR', 'PA', 'VI', 'GF'];

  const handleClick = () => {
    if (disabled) return;
    navigate(checked ? routes.protectedRoutes.gcs.path : routes.protectedRoutes.gcsByTax.path);
  };
  return !disabledCountries.includes(country) ? (
    <FormGroup>
      <FormControlLabel
        onClick={handleClick}
        control={<Switch checked={checked} disabled={disabled} />}
        label={t('gcs-taxes.title') as string}
      />
    </FormGroup>
  ) : null;
};

export default GcsByTaxSwitch;
